import { Skeleton } from "antd";

export function UseCaseCardSkeleton() {
  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-md flex flex-col w-full h-auto min-h-[400px] mx-auto border border-overlay">
      {/* Image */}
      <div
        className="flex justify-center items-center w-full h-[140px] sm:h-[160px] lg:h-[180px] overflow-hidden relative flex-shrink-0
        sm:max-w-[380px]
        md:max-w-[460px]
        lg:max-w-[540px]
        xl:max-w-[640px]
        2xl:max-w-[760px]
      "
      >
        <Skeleton.Image active className="!w-20 !h-20" />
      </div>
      <div className="p-4 flex flex-col flex-grow justify-between">
        {/* Date skeleton */}
        <div className="flex items-center gap-3">
          <Skeleton.Input
            active
            style={{ width: 80, height: 16 }}
            size="small"
          />
        </div>

        {/* Title */}
        <Skeleton.Input
          active
          style={{ width: "90%", height: 24, marginTop: 16 }}
        />

        {/* Description */}
        <Skeleton
          active
          paragraph={{ rows: 3 }}
          title={false}
          style={{ marginTop: 16 }}
        />

        {/* Read more */}
        <Skeleton.Input
          active
          style={{ width: 120, height: 20, marginTop: 12 }}
          size="small"
        />
      </div>
    </div>
  );
}
